<template>
  <div>
    <v-card>
      <v-card-title>
        Pedidos
      </v-card-title>
      <v-card-text>
        <div>
          <v-skeleton-loader v-if="loading" type="table"></v-skeleton-loader>
          <v-data-table
            :headers="encabezados"
            :items="listado"
            :search="search"
            v-else
          >
            <template v-slot:header="{ props: { headers } }">
              <thead>
                <tr>
                  <th :colspan="headers.length">
                    <v-text-field
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Ingrese busqueda"
                      single-line
                      hide-details
                    ></v-text-field>
                  </th>
                </tr>
              </thead>
            </template>
            <template v-slot:item._id="{ item }">{{
              item._id.slice(-5)
            }}</template>
            <template v-slot:item.fechaAlta="{ item }">{{
              item.fechaAlta | moment("dddd D [de] MMMM YYYY HH:mm")
            }}</template>
            <template v-slot:item.acciones="{ item }">
              <v-icon
                small
                class="mr-2"
                @click="irPedido(item._id)"
              >mdi-eye</v-icon>
            </template>
          </v-data-table>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import axios from "axios" 
export default {
  name: "Pedidos_Listado",
  data() {
    return {
      encabezados: [
          {
          text: "#",
          align: "start",
          value: "_id",
        },
        {
          text: "Fecha y Hora",
          value: "fechaAlta",
        },
        { text: "Estado", value: "estado.texto" },
        { text: "Cliente", value: "cliente.nombre" },
        { text: "Subtotal", value: "subtotal" },
        { text: "Costo de Envio", value: "costoEnvio" },
        { text: "Total", value: "total" },
        {
          text: "Acciones",
          value: "acciones",
        },
      ],
      listado: [],
      search: '',
      loading: true
    };
  },
  methods: {
   async _obtenerPedidos() {
       this.loading = true
       try {
           const pedidos = await axios.get("/pedidos")
           this.listado = pedidos.data
       } catch (error) {
           console.log(error)
       }
       this.loading = false
   },
   irPedido(_id) {
       this.$router.push(`/pedido/${_id}`)
   }
  },
  created() {
      this._obtenerPedidos()
  }
};
</script>
